import { USE_MOCKS } from '../config/serviceConfig';
import { notificationMock } from './mock/notification.mock';
import { notificationReal } from './real/notification.real';
import type { INotificationService } from './interfaces/INotificationService';

export const notificationService: INotificationService = USE_MOCKS
  ? notificationMock
  : notificationReal;
